<!-- frontend/src/headless/atoms/HInput.vue -->
<script setup lang="ts">
import { ref, computed } from 'vue'
import type { ValidationRule } from './types'

const props = withDefaults(defineProps<{
  modelValue: string
  rules?: ValidationRule[]
}>(), {
  rules: () => [],
})

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const focused = ref(false)
const touched = ref(false)

const error = computed(() => {
  if (!touched.value || !props.rules.length) return ''
  for (const rule of props.rules) {
    const result = rule(props.modelValue)
    if (result !== true) return result
  }
  return ''
})

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.value)
}

const onFocus = () => {
  focused.value = true
}

const onBlur = () => {
  focused.value = false
  touched.value = true
}

const validate = () => {
  touched.value = true
  return !error.value
}

const reset = () => {
  touched.value = false
}
</script>

<template>
  <slot
    :value="modelValue"
    :error="error"
    :focused="focused"
    :touched="touched"
    :onInput="onInput"
    :onFocus="onFocus"
    :onBlur="onBlur"
    :validate="validate"
    :reset="reset"
  />
</template>
